import { render, staticRenderFns } from "./ProfileFilterStandard.vue?vue&type=template&id=6bfbbd28&scoped=true&"
import script from "./ProfileFilterStandard.vue?vue&type=script&lang=ts&"
export * from "./ProfileFilterStandard.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileFilterStandard.vue?vue&type=style&index=0&id=6bfbbd28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfbbd28",
  null
  
)

export default component.exports